// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__lQhFB","validationTips":"StatementDescriptor_validationTips__1-_g9"};